module.exports = __webpack_public_path__ + "img/sidebar-right.b75ab1cd.png";